import { useState, useEffect } from "react";
import axios from "axios";
import OtpInput from "react-otp-input";
import { FiEdit2 } from "react-icons/fi";
import Button from "../../../components/Button";
import toast from "react-hot-toast";

import "./style.css";
import { api } from "../../../api/url";

const GetVerifyCode = (props) => {
  const [otp, setOtp] = useState("");
  const [time, changeTimer] = useState(59);
  const [timeminute, changeTimerMinute] = useState(1);
  const [error, changeErr] = useState("");
  const [loading, setLoading] = useState(false);

  // ------------------- timer
  useEffect(() => {
    const timer = setTimeout(() => {
      if (time > 0) changeTimer(time - 1);
      else if (time === 0 && timeminute === 1) {
        changeTimer(60);
        changeTimerMinute(0);
      } else return;
    }, 1000);
    return () => clearTimeout(timer);
  }, [time]);

  // ------------------- verify Otp
  const VerifyOtp = async () => {
    changeErr("");
    if (otp.length === 4) {
      setLoading(true);
      await axios({
        url: api + "appointment/login/gettoken",
        method: "post",
        data: {
          mobileNo: props.userInfo.mobileNo,
          referralNo: Number(otp),
          firstName: props.userInfo.firstName,
          lastName: props.userInfo.lastName,
          nationalCode: props.userInfo.nationalCode,
          genderId: props.userInfo.genderId,
        },
      })
        .then((res) => {
          setLoading(false);

          if (res.data.httpStatus === 200) {
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("cellphone", res.data.data.mobileNo);
            localStorage.setItem("user", res.data.data.userId);
            toast.success("ورود با موفقیت‌آمیز انجام شد.");
            if (props.hasReserve) {
              props.ReserveFunc()
            } else {
              window.location.reload();
            }
          } else if (res.data.httpStatus === 406) {
            res.data.validationErrors.map((item) =>
              toast.error(item)
            )
          } else {
            toast.error("کد را مجدد بررسی کنید");

          }
        })
        .catch((err) => {
          toast.error("کد را مجدد بررسی کنید");
          setLoading(false);
        });
    } else {
      changeErr("کدتایید الزامی می‌باشد");
    }
  };

  useEffect(() => {
    if (otp.length === 4) VerifyOtp();
  }, [otp]);

  // ------------------- get otp
  const GetOtp = async () => {
    await axios({
      url: api + "appointment/login/getotp/" + props.userInfo.mobileNo,
      method: "get",
    })
      .then((res) => {
        changeTimer(59);
        changeTimerMinute(1);
      })
      .catch((err) => {
        console.log("err", err);
        // setSubmitting(false);
      });
  };

  return (
    <div className="modal-phonenumber-container">
      <h5>کد تایید</h5>
      <p className="verification-text">
        کدتایید ارسالی به شماره {props.userInfo.mobileNo}را وارد کنيد
      </p>

      <div className="input-section">
        <a className="edit-phonenumber" onClick={() => props.setStep(0)}>
          <FiEdit2 />
          اصلاح شماره موبایل
        </a>

        <OtpInput
          value={otp}
          onChange={setOtp}
          onPaste={VerifyOtp}
          shouldAutoFocus
          numInputs={4}
          inputType="tel"
          inputStyle={{ height: 50, width: 50 }}
          containerStyle={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            width: "70%",
            alignSelf: "center",
            direction: "ltr",
          }}
          renderSeparator={null}
          renderInput={(props) => (
            <input style={{ height: 50, width: 50 }} {...props} />
          )}
        />
        <div className="error">{error}</div>

        {time === 0 && timeminute === 0 ? (
          <button onClick={() => GetOtp()} className="resend-code">
            ارسال مجدد
          </button>
        ) : (
          <div className="verification-timer">
            {timeminute +
              ":" +
              (String(time).length < 2 ? "0" + time : time) +
              "    تا درخواست مجدد کد"}
          </div>
        )}
      </div>

      <Button
        className="modal-phonenumber-container-button "
        onClick={VerifyOtp}
        isSubmitting={loading}
      >
        تایید
      </Button>
    </div>
  );
};

export default GetVerifyCode;
